'use client';
import { useCallback, useEffect, useState } from 'react';

const getWindowDimensions = () => {
  if (typeof window === 'undefined') {
    return { width: null, height: null };
  }
  return { width: window.innerWidth, height: window.innerHeight };
};

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions);

  const handleResize = useCallback(() => {
    setWindowDimensions(getWindowDimensions());
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [handleResize]);

  return windowDimensions;
};
